import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-insurance-fill 276",
  "use": "icon-insurance-fill 276-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-insurance-fill 276\"><path d=\"M542.72 163.84v62.8736c164.4544 15.29856 293.66272 152.12544 296.89856 319.7952L839.68 552.96H542.72v194.56a102.4 102.4 0 0 1-204.6976 4.44416L337.92 747.52v-20.48h61.44v20.48a40.96 40.96 0 0 0 81.8176 3.072l0.1024-3.072V552.96H184.32c0-170.61888 130.39616-310.784 296.96-326.2464V163.84h61.44z\" p-id=\"19871\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol